module.exports = __webpack_public_path__ + "media/images/ziprecruiter-transparent-logo-d10d6b8cece5837d635021488c39295e.png";